import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import SingleTicker from 'Components/_charts/singleTicker'
import MultipleTickers from 'Components/_charts/multipleTickers'

@inject('store') @observer
class Charts extends Component {
  render() {
    const {all_tickers_count} = this.props.store.backtest.single.algo
    if (all_tickers_count === 1) {
      return(
        <SingleTicker id={this.props.id} ticker={this.props.ticker} store={this.props.store.backtest.charts} loading={this.props.loading}/>
      )
    } else if (all_tickers_count > 1) {
      return(
        <MultipleTickers id={this.props.id} ticker={this.props.ticker} store={this.props.store.backtest.charts} loading={this.props.loading}/>
      )
    } else {
      return null
    }
  }
}

export default Charts
